export default "__VITE_ASSET__3c53b1cd__"